import React, {useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Products from './Products.jsx'
import Details from './Details.jsx'
import Bundle from './Bundle.jsx'
import Review from './Review.jsx'
import { clearOtherSteps } from '../store/byoSlice'

const Byo = ({ data }) => { 
  const step = useSelector((state) => state.byo.step)
  const color = useSelector((state) => state.byo.color)
  const dispatch = useDispatch()
  setTimeout(() => {
    if(step == 1) dispatch(clearOtherSteps())
  }, 300)

  return (
    <div className='lg:h-screen flex flex-col-reverse lg:flex-row'>
      <div className={`${step < 5 ? 'lg:w-1/2' : 'lg:w-1/3'}`}>
        {
          step < 5 ? 
            <div className='flex h-full'>
              <Products data={ data } />
              <Details data={ data } />
            </div>
            :
            <Review data={ data } />
        }
      </div>
      <Bundle data={ data } />
    </div>
  )
}

export default Byo